const PENDING_CLAIM_TOKEN_KEY = 'eyesensePendingClaimToken';
const POST_AUTH_REDIRECT_KEY = 'eyesensePostAuthRedirect';

export function isSafeRedirect(path) {
  if (!path || typeof path !== 'string') return false;
  if (!path.startsWith('/')) return false;
  if (path.startsWith('//')) return false;
  if (path.includes('://')) return false;
  return true;
}

function writeSession(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch {
    // private mode
  }
}

function readSession(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

export function rememberPostAuthRedirect(path) {
  if (!isSafeRedirect(path)) return;
  writeSession(POST_AUTH_REDIRECT_KEY, path);
  const query = path.includes('?') ? path.slice(path.indexOf('?') + 1) : '';
  const token = new URLSearchParams(query).get('token');
  if (token && /^DT-[A-Za-z0-9]+$/.test(token)) {
    writeSession(PENDING_CLAIM_TOKEN_KEY, token);
  }
}

export function persistRedirectFromSearch(search) {
  const redirect = new URLSearchParams(search || '').get('redirect');
  if (isSafeRedirect(redirect)) {
    rememberPostAuthRedirect(redirect);
  }
}

export function rememberClaimTokenFromLocation(pathname, search) {
  persistRedirectFromSearch(search);
  if (pathname !== '/gateways') return;
  const token = new URLSearchParams(search).get('token');
  if (token && /^DT-[A-Za-z0-9]+$/.test(token)) {
    writeSession(PENDING_CLAIM_TOKEN_KEY, token);
    rememberPostAuthRedirect(`/gateways?token=${encodeURIComponent(token)}`);
  }
}

export function takePendingClaimToken() {
  const token = readSession(PENDING_CLAIM_TOKEN_KEY);
  if (token) {
    try {
      sessionStorage.removeItem(PENDING_CLAIM_TOKEN_KEY);
    } catch {
      // ignore
    }
  }
  return token;
}

export function postLoginPath(search) {
  persistRedirectFromSearch(search);
  const redirect = new URLSearchParams(search || '').get('redirect');
  if (isSafeRedirect(redirect)) return redirect;
  const saved = readSession(POST_AUTH_REDIRECT_KEY);
  if (isSafeRedirect(saved)) return saved;
  const pending = readSession(PENDING_CLAIM_TOKEN_KEY);
  if (pending && /^DT-[A-Za-z0-9]+$/.test(pending)) {
    return `/gateways?token=${encodeURIComponent(pending)}`;
  }
  return '/gateways';
}

/** /login or /register, carrying the claim/return URL when we have one. */
export function authPath(pathname, search) {
  const dest = postLoginPath(search);
  if (dest && dest !== '/gateways') {
    return `${pathname}?redirect=${encodeURIComponent(dest)}`;
  }
  return pathname;
}
